import { render, staticRenderFns } from "./WasteConfirmView.vue?vue&type=template&id=4347619c&"
import script from "./WasteConfirmView.vue?vue&type=script&lang=js&"
export * from "./WasteConfirmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports